<template>
  <div class="tableWithPerPageSelection">
    <div class="entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ getTitle }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button is-addOrEdit"
                      @click="checkPermissions(permContrat.maj) ?
                      $router.push({ name: 'm.baux.contrat-ajout'}) : showPopUp()"
                      :class="{ 'button-access-no-permission' :
                      !checkPermissions(permContrat.maj) }">
                {{ $t('listeContrat.actions.add')}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="tab">
        <ul>
          <li @click="updateActiveTab('liste-contrat')"
              :class="{'is-active': activeTab === 'liste-contrat'}">
            {{ $t('listeContrat.onglet.contrat')}}
          </li>
          <li @click="updateActiveTab('liste-contrat-reconductible')"
              :class="{'is-active': activeTab === 'liste-contrat-reconductible'}">
            {{ $t('listeContrat.onglet.contratReconductible')}}
          </li>
          <li @click="updateActiveTab('liste-contrat-materiel')"
              :class="{'is-active': activeTab === 'liste-contrat-materiel'}">
            {{ $t('listeContrat.onglet.materiel')}}
          </li>
        </ul>
      </div>
    </div>
    <component :is="activeTab"></component>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import { CONTRAT } from '@/configuration/baux/permissionsBauxConf';
import listeContrat from '@/components/baux/contrat/listeContrat';
import listeContratReconductible from '@/components/baux/contrat/listeContratReconductible';
import listeContratMateriel from '@/components/baux/contrat/listeContratMateriel';

const Permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      permContrat: CONTRAT,
      activeTab: null,
    };
  },
  components: {
    breadcrumb,
    listeContrat,
    listeContratReconductible,
    listeContratMateriel,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.getTitle, route: '', isActive: true },
      ];
    },
    getTitle() {
      switch (this.activeTab) {
        case 'liste-contrat':
          return this.$i18n.t('listeContrat.titleBaux');
        case 'liste-contrat-reconductible':
          return this.$i18n.t('listeContrat.titleBauxReconductible');
        default:
          return this.$i18n.t('listeContrat.titleBauxMateriel');
      }
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    updateActiveTab(activeTab) {
      this.activeTab = activeTab;
      switch (activeTab) {
        case 'liste-contrat':
          this.setInformationPage(this.$t('pageBaux.contrat.listeBaux'));
          break;
        case 'liste-contrat-reconductible':
          this.setInformationPage(this.$t('pageBaux.contrat.listeBauxReconductible'));
          break;
        default:
          this.setInformationPage(this.$t('pageBaux.contrat.listeBauxMateriel'));
          break;
      }
    },
  },
  mounted() {
    if (this.$route.name === 'l.baux.contrat-by-materiel') {
      this.updateActiveTab('liste-contrat-materiel');
      return;
    }
    this.updateActiveTab('liste-contrat');
  },
};
</script>
